/**
 * User Detail → Sticking Patterns.
 *
 * The same panel the Sticking Patterns explorer uses for a per-user drill-down,
 * scoped to this user. Thin by design — UserStickingPatternsPanel owns the query.
 *
 * See docs/FeatureDesigns/diagnosis/sticking-patterns-surfaces.md.
 */

import { UserStickingPatternsPanel } from '../../sticking-patterns/UserStickingPatternsPanel';

export function PatternsTab({ userId }: { userId: string }) {
  return <UserStickingPatternsPanel userId={userId} />;
}
